import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { A, an } from '@fullcalendar/core/internal-common';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ScheduleEffectiveTimeSettingService {
  constructor(private http: HttpClient) {}

  public searchScheduleEffectiveTimeSetting(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/searchScheduleEffectiveTimeSetting`;
    return this.http.post(url, request);
  }

  public saveScheduleEffectiveTimeSetting(saveRequest: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/saveScheduleEffectiveTimeSetting`;
    return this.http.post(url, saveRequest);
  }

  public searchScheduleEffectiveTimeSettingHeaderOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/getScheduleEffectiveTimeSettingHeaderOptions`;
    return this.http.get(url);
  }

  public deleteScheduleEffectiveTimeSetting(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/deleteScheduleEffectiveTimeSetting`;
    return this.http.post(url, request);
  }

  public searchUrgentList(scheduleName: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/searchUrgentList`;
    return this.http.post(url, { scheduleName });
  }
  
  public insertUrgentList(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/insertUrgentList`;
    return this.http.post(url, request);
  }

  public deleteUrgentList(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/scheduleSetting/deleteUrgentList`;
    return this.http.post(url, request);
  }
  
}
